export default __webpack_public_path__ + "static/media/accountSelectIcon.e22a1c59.svg";